(function () {
  const REVISION = '2026-04-15';
  const SUCCESS_MESSAGE = 'Thanks - check your inbox to confirm.';
  const ERROR_MESSAGE = "Couldn't sign you up - try again or email us.";

  const ATTRIBUTION_STORAGE_KEY = 'wacc_attribution';
  const ATTRIBUTION_PROPERTY_MAP = {
    gclid: 'gclid_last_seen',
    fbclid: 'fbclid_last_seen',
    ttclid: 'ttclid_last_seen',
    utm_source: 'utm_source_last_seen',
    utm_medium: 'utm_medium_last_seen',
    utm_campaign: 'utm_campaign_last_seen',
    utm_content: 'utm_content_last_seen',
    utm_term: 'utm_term_last_seen',
    _captured_at: 'attribution_captured_at',
  };

  function readCookie(name) {
    const prefix = `${name}=`;
    const cookies = document.cookie ? document.cookie.split(';') : [];

    for (const cookieValue of cookies) {
      const cookie = cookieValue.trim();

      if (cookie.indexOf(prefix) === 0) {
        return decodeURIComponent(cookie.slice(prefix.length));
      }
    }

    return null;
  }

  function readStoredAttribution() {
    let stored = null;

    try {
      stored = window.localStorage.getItem(ATTRIBUTION_STORAGE_KEY);
    } catch (error) {
      stored = null;
    }

    if (!stored) {
      stored = readCookie(ATTRIBUTION_STORAGE_KEY);
    }

    if (!stored) {
      return null;
    }

    try {
      return JSON.parse(stored);
    } catch (error) {
      return null;
    }
  }

  function buildProfileProperties(signupSource) {
    const properties = {
      signup_source: signupSource,
    };
    const attribution = readStoredAttribution();

    if (!attribution) {
      return properties;
    }

    Object.keys(ATTRIBUTION_PROPERTY_MAP).forEach((key) => {
      if (attribution[key]) {
        properties[ATTRIBUTION_PROPERTY_MAP[key]] = attribution[key];
      }
    });

    return properties;
  }

  function buildSubscriptionPayload(email, listId, signupSource) {
    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: signupSource,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: buildProfileProperties(signupSource),
                subscriptions: {
                  email: {
                    marketing: {
                      consent: 'SUBSCRIBED',
                    },
                  },
                },
              },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId,
            },
          },
        },
      },
    };
  }

  function setFeedback(form, message) {
    const feedback = form.querySelector('.wacc-newsletter-form__feedback');

    if (feedback) {
      feedback.textContent = message;
    }
  }

  function initForm(form) {
    if (form.dataset.initialized === 'true') {
      return;
    }

    form.dataset.initialized = 'true';

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const input = form.querySelector('input[name="email"]');
      const button = form.querySelector('button[type="submit"]');
      const email = input?.value.trim();
      const companyId = form.dataset.klaviyoPublicApiKey;
      const listId = form.dataset.klaviyoListId;
      const signupSource = form.dataset.signupSource || 'newsletter_section';

      if (!email || !input.checkValidity() || !companyId || !listId) {
        setFeedback(form, ERROR_MESSAGE);
        return;
      }

      button?.setAttribute('disabled', 'disabled');

      try {
        const url = new URL('https://a.klaviyo.com/client/subscriptions/');
        url.searchParams.set('company_id', companyId);

        const response = await fetch(url.toString(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            revision: REVISION,
          },
          body: JSON.stringify(buildSubscriptionPayload(email, listId, signupSource)),
        });

        if (!response.ok) {
          throw new Error('Klaviyo subscription failed');
        }

        form.reset();
        setFeedback(form, SUCCESS_MESSAGE);
      } catch (error) {
        setFeedback(form, ERROR_MESSAGE);
      } finally {
        button?.removeAttribute('disabled');
      }
    });
  }

  function initNewsletterForms() {
    document.querySelectorAll('.wacc-newsletter-form').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNewsletterForms);
  } else {
    initNewsletterForms();
  }

  document.addEventListener('shopify:section:load', initNewsletterForms);
})();
